
export const isOnlyCharacters = (inText) => {
    return inText.replace(/[^a-z\s]/gi, '');
};

export const isOnlyNumbers = (inNumbers) => {
    return inNumbers.replace(/\D/g, '');
};

export const isValidEmail = (email) => {
    return /\S+@\S+\.\S+/.test(email);
};

export const isValidPhone = (phone) => {
    return phone.length === 10 ? true : false
};

export const validateText = (text, lengthText = 150) => {
    if (text === undefined) return false;
    if (text === "") return true;

    const pattern = /^[A-Za-zäÄëËïÏöÖüÜáéíóúÁÉÍÓÚÂÊÎÔÛâêîôûàèìòùÀÈÌÒÙñÑ ]+$/;

    return text.length <= lengthText && pattern.test(text)
};

export const validatePhoneNumbers = (text) => {
    if (text === undefined) return false;
    if (text === "") return true;
    if (text.length !== 10) return false;

    const pattern = /^[0-9]+$/;
    return pattern.test(text);
};

export const validateMail = (text) => {
    if (text === undefined) return false;
    if (text === "") return true;

    const pattern =
        /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/;
    return pattern.test(text);
};